module.exports = __webpack_public_path__ + "img/leadership-1980-hu-qiaomu.a25ff5e9.jpg";